module.exports = __webpack_public_path__ + "static/media/64.416295de.jpg";